import {endPointPrivate} from './config'
import axios from 'axios'

export default {
  listarTabelaDefault: () => {
    return axios.get(endPointPrivate + 'v1/tabelaPrecoRepresentante')
  },
  listarNovidades: () => {
    return axios.get(endPointPrivate + 'v1/dashboard')
  },
  listarCategorias: (termo) => {
    return axios.get(endPointPrivate + 'v1/catalogoGradeProdutos?termo=' + termo)
  },
  listarBanners: () => {
    return axios.get(endPointPrivate + 'v1/banners')
  },
  detalhesItemCategoria: (param) => {
    return axios.get(endPointPrivate + 'v1/gradeProdutos?' + 'codigoGrade=' + param.codigoGrade + '&codigoTabelaPreco=' + param.codigoTabelaPreco)
  },
  detalhesItemNovidade: (param) => {
    return axios.get(endPointPrivate + 'v1/gradeProdutos?' + 'codProduto=' + param.codigoProduto + '&codigoTabelaPreco=' + param.codigoTabelaPreco)
  },
  selecionar: () => {
    return axios.get(endPointPrivate + 'v1/dadosTabelasCliente')
  }
}



// WEBPACK FOOTER //
// ./src/services/tableCatalogo.js